// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pos-activity-loader {
  --pos-loader-ink: #25364a;
  --pos-loader-muted: #64758a;
  --pos-loader-surface: #fbfcfe;
  --pos-loader-track: #d9e3ef;
  display: inline-flex;
  align-items: center;
  gap: 11px;
  min-height: 52px;
  padding: 10px 17px 10px 11px;
  border: 1px solid rgba(44, 73, 108, 0.11);
  border-radius: 999px;
  background: var(--pos-loader-surface);
  color: var(--pos-loader-ink);
  box-shadow: 0 8px 24px rgba(24, 48, 78, 0.12), 0 1px 3px rgba(24, 48, 78, 0.08);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1;
}

.pos-activity-loader__art {
  position: relative;
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  place-items: center;
}

.pos-activity-loader__mark {
  display: block;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  object-fit: cover;
}

.pos-activity-loader__orbit {
  position: absolute;
  inset: 0;
  border: 1.5px solid var(--pos-loader-track);
  border-top-color: #1769e8;
  border-radius: 50%;
  animation: pos-activity-loader-turn 1.15s cubic-bezier(0.55, 0.1, 0.45, 0.9) infinite;
}

.pos-activity-loader__label {
  color: var(--pos-loader-muted);
}

@keyframes pos-activity-loader-turn {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-color-scheme: dark) {
  .pos-activity-loader {
    --pos-loader-ink: #e4ebf4;
    --pos-loader-muted: #c1ccda;
    --pos-loader-surface: #202a37;
    --pos-loader-track: #435267;
    border-color: rgba(210, 224, 242, 0.13);
    box-shadow: 0 8px 24px rgba(4, 12, 22, 0.3), 0 1px 3px rgba(4, 12, 22, 0.22);
  }
}

.dark .pos-activity-loader,
[data-theme="dark"] .pos-activity-loader {
  --pos-loader-ink: #e4ebf4;
  --pos-loader-muted: #c1ccda;
  --pos-loader-surface: #202a37;
  --pos-loader-track: #435267;
  border-color: rgba(210, 224, 242, 0.13);
  box-shadow: 0 8px 24px rgba(4, 12, 22, 0.3), 0 1px 3px rgba(4, 12, 22, 0.22);
}

@media (prefers-reduced-motion: reduce) {
  .pos-activity-loader,
  .pos-activity-loader *,
  .pos-activity-loader *::before,
  .pos-activity-loader *::after {
    animation: none !important;
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/components/PosActivityLoader/PosActivityLoader.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;EACzC,oBAAoB;EACpB,qCAAqC;EACrC,4BAA4B;EAC5B,+EAA+E;EAC/E,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,qFAAqF;AACvF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,uCAAuC;IACvC,4EAA4E;EAC9E;AACF;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,uCAAuC;EACvC,4EAA4E;AAC9E;;AAEA;EACE;;;;IAIE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF","sourcesContent":[".pos-activity-loader {\n  --pos-loader-ink: #25364a;\n  --pos-loader-muted: #64758a;\n  --pos-loader-surface: #fbfcfe;\n  --pos-loader-track: #d9e3ef;\n  display: inline-flex;\n  align-items: center;\n  gap: 11px;\n  min-height: 52px;\n  padding: 10px 17px 10px 11px;\n  border: 1px solid rgba(44, 73, 108, 0.11);\n  border-radius: 999px;\n  background: var(--pos-loader-surface);\n  color: var(--pos-loader-ink);\n  box-shadow: 0 8px 24px rgba(24, 48, 78, 0.12), 0 1px 3px rgba(24, 48, 78, 0.08);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1;\n}\n\n.pos-activity-loader__art {\n  position: relative;\n  display: grid;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  place-items: center;\n}\n\n.pos-activity-loader__mark {\n  display: block;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  object-fit: cover;\n}\n\n.pos-activity-loader__orbit {\n  position: absolute;\n  inset: 0;\n  border: 1.5px solid var(--pos-loader-track);\n  border-top-color: #1769e8;\n  border-radius: 50%;\n  animation: pos-activity-loader-turn 1.15s cubic-bezier(0.55, 0.1, 0.45, 0.9) infinite;\n}\n\n.pos-activity-loader__label {\n  color: var(--pos-loader-muted);\n}\n\n@keyframes pos-activity-loader-turn {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .pos-activity-loader {\n    --pos-loader-ink: #e4ebf4;\n    --pos-loader-muted: #c1ccda;\n    --pos-loader-surface: #202a37;\n    --pos-loader-track: #435267;\n    border-color: rgba(210, 224, 242, 0.13);\n    box-shadow: 0 8px 24px rgba(4, 12, 22, 0.3), 0 1px 3px rgba(4, 12, 22, 0.22);\n  }\n}\n\n.dark .pos-activity-loader,\n[data-theme=\"dark\"] .pos-activity-loader {\n  --pos-loader-ink: #e4ebf4;\n  --pos-loader-muted: #c1ccda;\n  --pos-loader-surface: #202a37;\n  --pos-loader-track: #435267;\n  border-color: rgba(210, 224, 242, 0.13);\n  box-shadow: 0 8px 24px rgba(4, 12, 22, 0.3), 0 1px 3px rgba(4, 12, 22, 0.22);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pos-activity-loader,\n  .pos-activity-loader *,\n  .pos-activity-loader *::before,\n  .pos-activity-loader *::after {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
